import { render, staticRenderFns } from "./bar4.vue?vue&type=template&id=65628edf&scoped=true&"
import script from "./bar4.vue?vue&type=script&lang=js&"
export * from "./bar4.vue?vue&type=script&lang=js&"
import style0 from "./bar4.vue?vue&type=style&index=0&id=65628edf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65628edf",
  null
  
)

export default component.exports